import { DialogBackdrop } from "../../../../../../ui/dialog/backdrop.js";
import { DialogPopup } from "../../../../../../ui/dialog/popup.js";
import { ErrorDialogClose } from "../../../../../../ui/error-dialog/close.js";
import { ErrorDialogDescription } from "../../../../../../ui/error-dialog/description.js";
import { ErrorDialogRoot } from "../../../../../../ui/error-dialog/root.js";
import { ErrorDialogTitle } from "../../../../../../ui/error-dialog/title.js";
import { Button } from "../../../components/buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/internal/skins/shared/skins/shared/audio/error-dialog.tsx
/** @jsxImportSource react */
function AudioErrorDialog() {
	return /* @__PURE__ */ jsxs(ErrorDialogRoot, { children: [/* @__PURE__ */ jsx(DialogBackdrop, { className: "audio-dialog-backdrop" }), /* @__PURE__ */ jsxs(DialogPopup, {
		className: "audio-dialog-popup",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "audio-dialog-content",
			children: [/* @__PURE__ */ jsx(ErrorDialogTitle, { className: "audio-dialog-title" }), /* @__PURE__ */ jsx(ErrorDialogDescription, { className: "audio-dialog-description" })]
		}), /* @__PURE__ */ jsx("div", {
			className: "audio-dialog-actions",
			children: /* @__PURE__ */ jsx(ErrorDialogClose, {
				render: /* @__PURE__ */ jsx(Button, {}),
				className: "audio-dialog-close"
			})
		})]
	})] });
}
//#endregion
export { AudioErrorDialog };

//# sourceMappingURL=error-dialog.js.map